import React, { useEffect, useState } from "react"
import {
  Row,
  Col,
  Card,
  Form,
  CardBody,
  CardTitle,
  Container,
  Table,
  Button,
  Input,
} from "reactstrap"
import Dropzone from "react-dropzone"
import { Link } from "react-router-dom"
import Select from "react-select"
// datatable related plugins
import BootstrapTable from "react-bootstrap-table-next"
import { useDispatch, useSelector } from "react-redux"
import "react-phone-number-input/style.css"
import PhoneInput from "react-phone-number-input"
import { init } from "echarts"
import { isArray, isEqual, set } from "lodash"

const TestNode = props => {
  const [contactName, setcontactName] = useState([{ id: 1, data: "" }])
  const [contactEmail, setcontactEmail] = useState([{ id: 1, data: "" }])
  const [contactPhone, setcontactPhone] = useState([{ id: 1, data: "" }])
  const [contactIM, setcontactIM] = useState([{ id: 1, data: "" }])
  const [contactOperator, setcontactOperator] = useState([{ id: 1, data: "" }])
  const [formRows, setFormRows] = useState([])
  const mainState = props.main_state
  const defaultState = props.existData
  const setState = props.setState;
  const SendState = props.main_state
  const [valueName, setValueName] = useState([])
  const [valueEmail, setValueEmail] = useState([])
  const [valuePhone, setValuePhone] = useState([])
  const [valueIM, setValueIM] = useState([])
  const [valueOperator, setValueOperator] = useState([])
  const [initialState, setIntialState] = useState(1)
  const operators = props.operators
  const editing = props.editing
  // console.log(props.selectedMulti);
  const selectedOperators_temp = Array.isArray(props.selectedMulti) ? props.selectedMulti.map(obj => obj.id) : [];
  const [selectedOperators, setselectedOperators] = useState(selectedOperators_temp)
  const availableOperators = operators?.filter(obj =>
    selectedOperators?.includes(obj.id)
  )
  const [selectedMulti, setselectedMulti] = useState(selectedOperators_temp)
  const [valueComments, setValueComments] = useState([])
  const [contactComments, setcontactComments] = useState([{ id: 1, data: "" }])

  const onAddFormRow = () => {
    const modifiedRows = [...formRows]
    // console.log(modifiedRows);
    var temp_id = modifiedRows.length + 1
    // var data = {
    //   key: temp_id,
    // }
    modifiedRows.push({ id: modifiedRows.length + 1 })
    // mainState.push(data)
    setFormRows(modifiedRows)
  }
  const onDeleteFormRow = id_1 => {
    var id = id_1
    // console.log('id',id);
    if (id != 1 && id > 1) {
      var previd = 1
      // console.log(formRows);
      var modifiedRows = [...formRows]
      // console.log("before",modifiedRows);
      var i = modifiedRows.findIndex(obj => obj["id"] == id)
      modifiedRows = modifiedRows.filter(x => x["id"] != id)
      while (i < modifiedRows.length) {
        modifiedRows[i].id--
        i++
      }
      // console.log("After",modifiedRows);
      setFormRows(modifiedRows)
    }
    if (id == 1 && formRows.length > 1) {
      id = id + 1
      // console.log(formRows);
      var modifiedRows = [...formRows]
      // console.log('before',modifiedRows);
      var i = modifiedRows.findIndex(obj => obj["id"] == id)
      modifiedRows = modifiedRows.filter(x => x["id"] != id)
      while (i < modifiedRows.length) {
        modifiedRows[i].id--
        i++
      }
      // console.log('after',modifiedRows);
      setFormRows(modifiedRows)
    }
    var i = mainState.findIndex(obj => obj.key == id_1)
    // console.log(i);
    mainState.splice(i, 1)
    // while (i < mainState.length) {
    //   mainState[i].key--
    //   i++
    // }
    mainState.forEach((obj, index) => {
      obj.key = index + 1;
    });
    // console.log(mainState);
  }
  const deletAll = id => {
    if (
      (valueName?.filter(obj => obj.key == id).map(obj => obj.data))[0] != null
    ) {
      deleteName(id)
    }
    if (
      (valueEmail?.filter(obj => obj.key == id).map(obj => obj.data))[0] != null
    ) {
      deleteEmail(id)
    }
    if (
      (valuePhone?.filter(obj => obj.key == id).map(obj => obj.data))[0] != null
    ) {
      deletePhone(id)
    }
    if (
      (valueIM?.filter(obj => obj.key == id).map(obj => obj.data))[0] != null
    ) {
      deleteIM(id)
    }
    if (
      (valueOperator?.filter(obj => obj.key == id).map(obj => obj.data))[0] !=
      null
    ) {
      deleteOperator(id)
    }
    if (
      (valueComments?.filter(obj => obj.key == id).map(obj => obj.data))[0] != null
    ) {
      deleteComments(id)
    }
  }
  const setName = (e, id) => {
    var temp = [...valueName]
    if (e != null && id != null) {
      //console.log(projectLongitude);

      //console.log("KEYS"+mainState.map(obj=>obj.key));
      var tempid = id
      var templongt = e

      var data = {
        key: tempid,
        data: templongt,
      }
      if (temp.map(obj => obj.key).includes(data.key) == false) {
        temp.push(data)
      } else if (temp.map(obj => obj.key).includes(data.key) == true) {
        var objIndex = temp.findIndex(obj => obj.key == data.key)

        temp[objIndex].data = data.data
      }

      // console.log(mainState);
    }
    setValueName(temp)
  }
  const deleteName = id => {
    var temp = [...valueName]
    var i = temp.findIndex(obj => obj.key == id)
    temp.splice(i, 1)
    // while (i < temp.length) {
    //   temp[i].key--
    //   i++
    // }
    temp.forEach((obj, index) => {
      obj.key = index + 1;
    });
    setValueName(temp)
  }
  const setEmail = (e, id) => {
    var temp = [...valueEmail]
    if (e != null && id != null) {
      //console.log(projectLongitude);

      //console.log("KEYS"+mainState.map(obj=>obj.key));
      var tempid = id
      var templongt = e

      var data = {
        key: tempid,
        data: templongt,
      }
      if (temp.map(obj => obj.key).includes(data.key) == false) {
        temp.push(data)
      } else if (temp.map(obj => obj.key).includes(data.key) == true) {
        var objIndex = temp.findIndex(obj => obj.key == data.key)

        temp[objIndex].data = data.data
      }

      // console.log(mainState);
    }
    setValueEmail(temp)
  }
  const deleteEmail = id => {
    var temp = [...valueEmail]
    var i = temp.findIndex(obj => obj.key == id)
    temp.splice(i, 1)
    // while (i < temp.length) {
    //   temp[i].key--
    //   i++
    // }
    temp.forEach((obj, index) => {
      obj.key = index + 1;
    });
    setValueEmail(temp)
  }
  const setPhone = (e, id) => {
    var temp = [...valuePhone]
    if (e != null && id != null) {
      //console.log(projectLongitude);

      //console.log("KEYS"+mainState.map(obj=>obj.key));
      var tempid = id
      var templongt = e

      var data = {
        key: tempid,
        data: templongt,
      }
      if (temp.map(obj => obj.key).includes(data.key) == false) {
        temp.push(data)
      } else if (temp.map(obj => obj.key).includes(data.key) == true) {
        var objIndex = temp.findIndex(obj => obj.key == data.key)

        temp[objIndex].data = data.data
      }

      // console.log(mainState);
    }
    setValuePhone(temp)
  }
  const deletePhone = id => {
    var temp = [...valuePhone]
    var i = temp.findIndex(obj => obj.key == id)
    temp.splice(i, 1)
    // while (i < temp.length) {
    //   temp[i].key--
    //   i++
    // }
    temp.forEach((obj, index) => {
      obj.key = index + 1;
    });
    setValuePhone(temp)
  }
  const setIM = (e, id) => {
    var temp = [...valueIM]
    if (e != null && id != null) {
      //console.log(projectLongitude);

      //console.log("KEYS"+mainState.map(obj=>obj.key));
      var tempid = id
      var templongt = e

      var data = {
        key: tempid,
        data: templongt,
      }
      if (temp.map(obj => obj.key).includes(data.key) == false) {
        temp.push(data)
      } else if (temp.map(obj => obj.key).includes(data.key) == true) {
        var objIndex = temp.findIndex(obj => obj.key == data.key)

        temp[objIndex].data = data.data
      }

      // console.log(mainState);
    }
    setValueIM(temp)
  }
  const deleteIM = id => {
    var temp = [...valueIM]
    var i = temp.findIndex(obj => obj.key == id)
    temp.splice(i, 1)
    // while (i < temp.length) {
    //   temp[i].key--
    //   i++
    // }
    temp.forEach((obj, index) => {
      obj.key = index + 1;
    });
    setValueIM(temp)
  }
  const setOperator = (e, id) => {
    var temp = [...valueOperator]
    if (e != null && id != null) {
      //console.log(projectLongitude);

      //console.log("KEYS"+mainState.map(obj=>obj.key));
      var tempid = id
      var templongt = e

      var data = {
        key: tempid,
        data: templongt,
      }
      if (temp.map(obj => obj.key).includes(data.key) == false) {
        temp.push(data)
      } else if (temp.map(obj => obj.key).includes(data.key) == true) {
        var objIndex = temp.findIndex(obj => obj.key == data.key)

        temp[objIndex].data = data.data
      }
    }
    setValueOperator(temp)
  }
  const deleteOperator = id => {
    var temp = [...valueOperator]
    var i = temp.findIndex(obj => obj.key == id)
    temp.splice(i, 1)
    // while (i < temp.length) {
    //   temp[i].key--
    //   i++
    // }
    temp.forEach((obj, index) => {
      obj.key = index + 1;
    });
    setValueOperator(temp)
  }
  const batchDeleteFormRows = (deletedIds) => {
    // Filter out deleted rows first
    // console.log(deletedIds);
    let newFormRows = formRows.filter(row => !deletedIds.includes(row.id));
    // Adjust the IDs
    newFormRows.forEach((row, index) => {
      row.id = index + 1;
    });
    // console.log(newFormRows);
    if(newFormRows.length == 0) {
      newFormRows.push({ id: 1 });
    }
    setFormRows(newFormRows);
  
    // Adjust mainState similarly
    let tempState = mainState.filter(state => !deletedIds.includes(state.key));
    tempState.forEach((state, index) => {
      state.key = index + 1;
    });
    setState(tempState);
    // Assuming mainState is a state variable, update it similarly
    // setMainState(newMainState);
  };
  const batchDeleteAll = (deletedIds) => {
    let tempName = [...valueName]
    let tempEmail = [...valueEmail]
    let tempPhone = [...valuePhone]
    let tempIM = [...valueIM]
    let tempOperator = [...valueOperator]

    let tempNameState = tempName.filter(obj => !deletedIds.includes(obj.key));
    let tempEmailState = tempEmail.filter(obj => !deletedIds.includes(obj.key));
    let tempPhoneState = tempPhone.filter(obj => !deletedIds.includes(obj.key));
    let tempIMState = tempIM.filter(obj => !deletedIds.includes(obj.key));
    let tempOperatorState = tempOperator.filter(obj => !deletedIds.includes(obj.key));

    tempNameState.forEach((obj, index) => {
      obj.key = index + 1;
    })
    tempEmailState.forEach((obj, index) => {
      obj.key = index + 1;
    })
    tempPhoneState.forEach((obj, index) => {
      obj.key = index + 1;
    })
    tempIMState.forEach((obj, index) => {
      obj.key = index + 1;
    })
    tempOperatorState.forEach((obj, index) => {
      obj.key = index + 1;
    })

    setValueName(tempNameState)
    setValueEmail(tempEmailState)
    setValuePhone(tempPhoneState)
    setValueIM(tempIMState)
    setValueOperator(tempOperatorState)
  };
  const setComments = (e, id) => {
    var temp = [...valueComments]
    if (e != null && id != null) {
      var tempid = id
      var tempcomment = e
      var data = {
        key: tempid,
        data: tempcomment,
      }
      if (temp.map(obj => obj.key).includes(data.key) == false) {
        temp.push(data)
      } else if (temp.map(obj => obj.key).includes(data.key) == true) {
        var objIndex = temp.findIndex(obj => obj.key == data.key)
        temp[objIndex].data = data.data
      }
    }
    setValueComments(temp)
  }
  const deleteComments = id => {
    var temp = [...valueComments]
    var i = temp.findIndex(obj => obj.key == id)
    temp.splice(i, 1)
    temp.forEach((obj, index) => {
      obj.key = index + 1;
    });
    setValueComments(temp)
  }

  if (initialState == 1) {
    // console.log(mainState);
    var tempName = [...valueName]
    var tempEmail = [...valueEmail]
    var tempPhone = [...valuePhone]
    var tempIM = [...valueIM]
    var tempOperator = [...valueOperator]

    const modifiedRows = [...formRows]

    if (SendState.length == 0) {
      // console.log("Triggered default");
      modifiedRows.push({ id: modifiedRows.length + 1 })
      var temp_id = modifiedRows.length
      var data = {
        key: temp_id,
      }
      var data_name = {
        key: 1,
        data: "",
      }
      var data_email = {
        key: 1,
        data: "",
      }
      var data_phone = {
        key: 1,
        data: "",
      }
      var data_im = {
        key: 1,
        data: "",
      }
      var data_operator = {
        key: 1,
        data: "",
      }

      //console.log(data);
      //mainState.push(data);
      tempName.push(data_name)
      //console.log(valueCountry);
      tempEmail.push(data_email)
      //console.log(valueLongt);
      tempPhone.push(data_phone)
      //console.log(valueLat);
      tempIM.push(data_im)
      //console.log(valueState);
      tempOperator.push(data_operator)
    }

    for (var obj of SendState) {
      modifiedRows.push({ id: modifiedRows.length + 1 })
    }

    SendState.forEach(async (ele, index) => {
      ele.key = index + 1
    })

    SendState.forEach((ele, index) => {
      // console.log(ele);
      var data = {
        key: index + 1,
        data: ele.name,
      }
      tempName.push(data)
      // console.log(tempName);
    })
    SendState.forEach((ele, index) => {
      var data = {
        key: index + 1,
        data: ele.email,
      }
      tempEmail.push(data)
      // console.log(tempEmail);
    })
    SendState.forEach((ele, index) => {
      var data = {
        key: index + 1,
        data: ele.phone,
      }
      tempPhone.push(data)
      // console.log(tempPhone);
    })
    SendState.forEach((ele, index) => {
      var data = {
        key: index + 1,
        data: ele.im,
      }
      tempIM.push(data)
      // console.log(tempIM);
    })
    SendState.forEach((ele, index) => {
      var data = {
        key: index + 1,
        data: ele.operator,
      }
      tempOperator.push(data)
    })

    // Load comments from SendState
    var tempComments = [...valueComments];
    SendState.forEach((ele, index) => {
      var data = {
        key: index + 1,
        data: ele.comments,
      }
      tempComments.push(data);
    });
    setValueComments(tempComments);

    var tempContactComments = [];
    SendState.forEach((ele, index) => {
      var data = {
        id: index + 1,
        data: ele.comments,
      }
      tempContactComments.push(data);
    });
    setcontactComments(tempContactComments);

    setValueName(tempName)
    setValueEmail(tempEmail)
    setValuePhone(tempPhone)
    setValueIM(tempIM)
    setValueOperator(tempOperator)
    setFormRows(modifiedRows)
    setIntialState(2)
  }

  useEffect(() => {
    //console.log("hello");
    if (contactName["id"] != null && contactName["data"] != null) {
      var tempid = contactName["id"]
      var tempcountry = contactName["data"]

      var data = {
        key: tempid,
        name: contactName["data"],
      }
      if (mainState.map(obj => obj.key).includes(data.key) == false) {
        mainState.push(data)
      } else if (mainState.map(obj => obj.key).includes(data.key) == true) {
        var objIndex = mainState.findIndex(obj => obj.key == data.key)

        mainState[objIndex].name = data.name
      }
    }
  }, [contactName])

  useEffect(() => {
    //console.log("hello");
    if (contactEmail["id"] != null && contactEmail["data"] != null) {
      var tempid = contactEmail["id"]
      var tempcountry = contactEmail["data"]

      var data = {
        key: tempid,
        email: contactEmail["data"],
      }
      if (mainState.map(obj => obj.key).includes(data.key) == false) {
        mainState.push(data)
      } else if (mainState.map(obj => obj.key).includes(data.key) == true) {
        var objIndex = mainState.findIndex(obj => obj.key == data.key)

        mainState[objIndex].email = data.email
      }
    }
  }, [contactEmail])

  useEffect(() => {
    //console.log("hello");
    if (contactPhone["id"] != null && contactPhone["data"] != null) {
      var tempid = contactPhone["id"]
      var tempcountry = contactPhone["data"]

      var data = {
        key: tempid,
        phone: contactPhone["data"],
      }
      if (mainState.map(obj => obj.key).includes(data.key) == false) {
        mainState.push(data)
      } else if (mainState.map(obj => obj.key).includes(data.key) == true) {
        var objIndex = mainState.findIndex(obj => obj.key == data.key)

        mainState[objIndex].phone = data.phone
      }
    }
  }, [contactPhone])

  useEffect(() => {
    //console.log("hello");
    if (contactIM["id"] != null && contactIM["data"] != null) {
      var tempid = contactIM["id"]
      var tempcountry = contactIM["data"]

      var data = {
        key: tempid,
        im: contactIM["data"],
      }
      if (mainState.map(obj => obj.key).includes(data.key) == false) {
        mainState.push(data)
      } else if (mainState.map(obj => obj.key).includes(data.key) == true) {
        var objIndex = mainState.findIndex(obj => obj.key == data.key)

        mainState[objIndex].im = data.im
      }
    }
  }, [contactIM])

  useEffect(() => {
    //console.log("hello");
    if (contactOperator["id"] != null && contactOperator["data"] != null) {
      var tempid = contactOperator["id"]
      var tempcountry = contactOperator["data"]

      var data = {
        key: tempid,
        operator: contactOperator["data"],
      }
      if (mainState.map(obj => obj.key).includes(data.key) == false) {
        mainState.push(data)
      } else if (mainState.map(obj => obj.key).includes(data.key) == true) {
        var objIndex = mainState.findIndex(obj => obj.key == data.key)

        mainState[objIndex].operator = data.operator
      }
    }
  }, [contactOperator])


  useEffect(() => {
    // console.log(valueOperator);
    // console.log(selectedMulti);
    if (valueOperator && selectedMulti && initialState != 1 && isArray(selectedMulti) && isArray(valueOperator)){
      let deletedOperators = valueOperator.filter(obj=>{
        if(!selectedMulti.includes(obj.data) && obj.data!=null){
          return obj;
        }
      })
      // console.log(deletedOperators, valueOperator);
      if (deletedOperators.length > 0) {
        // deletedOperators.forEach(obj => {
        //   deletAll(obj.key)
        //   // onDeleteFormRow(obj.key)
        // })
        // console.log('triggered');
        batchDeleteFormRows(deletedOperators.map(obj => obj.key));
        batchDeleteAll(deletedOperators.map(obj => obj.key));
      }
    }
    // console.log(selectedOperators);
  }, [selectedMulti])

  useEffect(() => {
    if(!editing && isArray(props.selectedMulti)){
      setselectedOperators(props.selectedMulti.map(obj => obj.id))
    }
  }, [props.selectedMulti])
  

  useEffect(() => {
    if(!editing){
      if(isEqual(selectedOperators, selectedMulti)) return;
      setselectedMulti(selectedOperators)
    }
  }, [selectedOperators])

  useEffect(() => {
    if (contactComments["id"] != null && contactComments["data"] != null) {
      var tempid = contactComments["id"]
      var tempcomment = contactComments["data"]
      var data = {
        key: tempid,
        comments: contactComments["data"],
      }
      if (mainState.map(obj => obj.key).includes(data.key) == false) {
        mainState.push(data)
      } else if (mainState.map(obj => obj.key).includes(data.key) == true) {
        var objIndex = mainState.findIndex(obj => obj.key == data.key)
        mainState[objIndex].comments = data.comments
      }
    }
  }, [contactComments])

  // useEffect(() => {
  //   console.log("mainState", mainState);
  //   console.log("valueName", valueName);
  //   console.log("valueEmail", valueEmail);
  //   console.log("valuePhone", valuePhone);
  //   console.log("valueIM", valueIM);
  //   console.log("valueOperator", valueOperator);
  //   console.log("formRows", formRows);
  // }, [formRows, valueName, valueEmail, valuePhone, valueIM, valueOperator, mainState])
  

  return (
    <React.Fragment>
      <div className="bg-white ">
        <div className="container-fluid">
          <Row>
            {formRows.map((formRow, key) => (
              <Col md="12" key={key}>
                <div className="zero-margin">
                  <Row>
                    {/* <label htmlFor="name">
                      Test Node Contact : {formRow.id}
                    </label> */}
                    <Col md="3" className="d-flex align-items-center">
                      <label className="lable-customer">Operator</label>
                    </Col>
                    <Col md="3">
                      <Select
                        className="customer-mult-input"
                        // value={selectedMulti}
                        isClearable
                        // isMulti={true}
                        value={availableOperators?.filter(
                          obj =>
                            obj.id ==
                            valueOperator
                              ?.filter(obj => obj.key == formRow.id)
                              .map(obj => obj.data)[0]
                        )}
                        onChange={e => {
                          if(e){
                            setOperator(e.id, formRow.id),
                            setcontactOperator({
                              id: formRow.id,
                              data: e.id,
                            })
                          }
                          else{
                            setOperator("", formRow.id),
                            setcontactOperator({
                              id: formRow.id,
                              data: "",
                            })
                          }
                        }}
                        name="operator"
                        options={availableOperators}
                        placeholder="Select Operator"
                        classNamePrefix="select2-selection"
                      />
                    </Col>
                    <Col md="3" className="d-flex align-items-center">
                      <label className="lable-customer">Full Name</label>
                    </Col>
                    <Col md="3">
                      <Input
                        type="name"
                        className="customer-input"
                        placeholder="Enter the Full Name"
                        value={valueName
                          ?.filter(obj => obj.key == formRow.id)
                          .map(obj => obj.data)}
                        onChange={e => {
                          setName(e.target.value, formRow.id)
                          setcontactName({
                            id: formRow.id,
                            data: e.target.value,
                          })
                        }}
                      />
                    </Col>
                    <Col md="3" className="d-flex align-items-center">
                      <label className="lable-customer">Phone</label>
                    </Col>
                    <Col md="3">
                      {/* <Input
                      type="name"
                      className="customer-input"
                      placeholder="Enter the Phone No."
                      value={valuePhone?.filter(obj=>obj.key==formRow.id).map(obj=>obj.data)}
                      onChange = {(e)=>{
                        setPhone(e.target.value,formRow.id),
                        setcontactPhone({id:formRow.id,data:e.target.value})
                      }}
                      /> */}
                      <PhoneInput
                        className="customer-phone-input"
                        placeholder="Enter phone number"
                        value={valuePhone
                          ?.filter(obj => obj.key == formRow.id)
                          .map(obj => obj.data)
                          .toString()}
                        onChange={e => {
                          setPhone(e, formRow.id),
                            setcontactPhone({ id: formRow.id, data: e })
                        }}
                      />
                    </Col>
                    <Col md="3" className="d-flex align-items-center">
                      <label className="lable-customer">Email</label>
                    </Col>
                    <Col md="3">
                      <Input
                        type="name"
                        className="customer-input"
                        placeholder="Enter the Email Add."
                        value={valueEmail
                          ?.filter(obj => obj.key == formRow.id)
                          .map(obj => obj.data)}
                        onChange={e => {
                          setEmail(e.target.value, formRow.id),
                            setcontactEmail({
                              id: formRow.id,
                              data: e.target.value,
                            })
                        }}
                      />
                    </Col>
                    <Col md="3" className="d-flex align-items-center">
                      <label className="lable-customer">Comments</label>
                    </Col>
                    <Col md="3">
                      <Input
                        type="text"
                        className="customer-input"
                        placeholder="Enter comments"
                        value={valueComments
                          ?.filter(obj => obj.key == formRow.id)
                          .map(obj => obj.data)}
                        onChange={e => {
                          setComments(e.target.value, formRow.id)
                          setcontactComments({
                            id: formRow.id,
                            data: e.target.value,
                          })
                        }}
                      />
                    </Col>
                    <Col md="3" className="d-flex align-items-center">
                      <label className="lable-customer">IM</label>
                    </Col>
                    <Col md="3">
                      <Input
                        type="name"
                        className="customer-input"
                        placeholder="IM"
                        value={valueIM
                          ?.filter(obj => obj.key == formRow.id)
                          .map(obj => obj.data)}
                        onChange={e => {
                          setIM(e.target.value, formRow.id),
                            setcontactIM({
                              id: formRow.id,
                              data: e.target.value,
                            })
                        }}
                      />
                    </Col>
                    <Col md="6"></Col>
                    <Col>
                      <Row className="btn-colection-right">
                        <Col md="2">
                          <div className="d-grid">
                            <Input
                              type="button"
                              className="btn btn-primary"
                              id="delete2"
                              value="Delete"
                              onClick={() => {
                                onDeleteFormRow(formRow.id)
                                deletAll(formRow.id)
                              }}
                            />
                          </div>
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                </div>
              </Col>
            ))}
          </Row>

          <Row className="btn-colection-right">
            <Col md="2">
              <div className="d-grid">
                <Button
                  onClick={() => {
                    //   handleAddRowNestedismsc();
                    onAddFormRow()
                  }}
                  className="btn btn-primary add-smsc "
                >
                  Add Number
                </Button>
              </div>
            </Col>
          </Row>
        </div>
      </div>

      {/* <button onClick={() => onAddFormRow()}className="responce-btn" id="img-btn" type="button"><i className="bx bx-add-to-queue"></i> Add New </button> */}
    </React.Fragment>
  )
}

export default TestNode
